import React from 'react';
import styled from 'styled-components';
import { IndexPanel } from './components/IndexPanel';
import {
  PERSISTENCE_COLOR,
  PERSISTENCE_DIMENSIONS,
  PERSISTENCE_FILL,
  WELLBEING_COLOR,
  WELLBEING_DIMENSIONS,
  WELLBEING_FILL,
} from './AssessmentIndex.constants';
import { AssessmentIndexData } from './AssessmentIndex.types';

export const AssessmentIndexWidget = ({ index }: { index: AssessmentIndexData }) => {
  const wellbeingValues = WELLBEING_DIMENSIONS.map(
    ({ key }) => index.wellbeingIndex.dimensions[key]
  );
  const persistenceValues = PERSISTENCE_DIMENSIONS.map(
    ({ key }) => index.persistenceIndex.dimensions[key]
  );

  return (
    <IndexCardsDiv>
      <IndexPanel
        title="Wellbeing Index"
        score={index.wellbeingIndex.score}
        delta={index.wellbeingIndex.scoreDelta}
        color={WELLBEING_COLOR}
        fill={WELLBEING_FILL}
        labels={WELLBEING_DIMENSIONS.map(({ label }) => label)}
        values={wellbeingValues}
      />
      <IndexPanel
        circular
        title="Persistence Index"
        score={index.persistenceIndex.score}
        delta={index.persistenceIndex.scoreDelta}
        color={PERSISTENCE_COLOR}
        fill={PERSISTENCE_FILL}
        labels={PERSISTENCE_DIMENSIONS.map(({ label }) => label)}
        values={persistenceValues}
      />
    </IndexCardsDiv>
  );
};

const IndexCardsDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;
